import { render } from "./EdicionPreguntas.vue?vue&type=template&id=be6b50c4"
import script from "./EdicionPreguntas.vue?vue&type=script&lang=js"
export * from "./EdicionPreguntas.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__